import Head from 'next/head';
import Image from 'next/image';
import Link from 'next/link';
import { useEffect, useState } from 'react';

import { useGetBlogs } from '@/api/blogs';
import BlogHeaderTile2 from '@/assets/blogAssets/2/BlogHeaderTile2.jpg';
import BlogHeaderTile6 from '@/assets/blogAssets/6/BlogHeaderTile6.jpg';
import BlogHeaderTile9 from '@/assets/blogAssets/9/BlogHeaderTile9.jpg';
import BlogHeroIcon from '@/assets/images/icons/blog-hero-icon.svg';
import { BlogsSEO } from '@/utils/constants/MetaData';

import Card from '../../common/components/Card/Card';

const PAGE_SIZE = 6;

export default function HomePage() {
  // FALLBACK UI
  const [pageNumber, setPageNumber] = useState(1);

  const [blogArray, setBlogArray] = useState<any[]>([]);

  const { data: resp, isSuccess } = useGetBlogs(pageNumber, PAGE_SIZE, {});
  const strapiBlogs = resp?.data?.blogListings?.data || [];
  const pagination = resp?.data?.blogListings?.meta?.pagination;

  console.log({ strapiBlogs });

  useEffect(() => {
    if (isSuccess) {
      if (pageNumber == 1) {
        setBlogArray(strapiBlogs || []);
      } else {
        setBlogArray([...blogArray, ...(strapiBlogs || [])]);
      }
    }
  }, [pageNumber, isSuccess]);

  const blogsCards =
    isSuccess && strapiBlogs.length !== 0 ? (
      blogArray.map((blog: any, index: number) => {
        return (
          <Card
            key={index.toString()}
            heading={blog.attributes.title}
            info={blog.attributes.description}
            imageSrc={blog.attributes.imgSrc?.data?.attributes?.url}
            slug={`blogs/${blog.attributes.slug}`}
          />
        );
      })
    ) : (
      <div className="container">
        <p className="section__desc text--black text-center">
          No Blogs Available
        </p>
      </div>
    );

  // const blogsCards = BlogsData.map((blog: any, index: number) => {
  //   return (
  //     <Card
  //       key={index.toString()}
  //       heading={blog.title}
  //       info={blog.description}
  //       imageSrc={blog.imageSrc}
  //       slug={blog.url}
  //     />
  //   );
  // });

  return (
    <>
      <Head>
        <title>{BlogsSEO.metaTitle}</title>
        <meta name="description" content={BlogsSEO.metaDescription} />
        <meta property="og:description" content={BlogsSEO.metaOGDescription} />
        <link rel="canonical" href="https://muthootfincorpone.com/blogs/" />
      </Head>
      <main className="home blogs font-helvetica-neue">
        <section className="bg bg--dark blogs__heros">
          <div className="container">
            <div className="row align-items-center">
              <div className="col-lg-6">
                <h1 className="section__title text--white">
                  Top Reads On The{' '}
                  <span className="text--white">Latest Trends</span>
                </h1>
                <p className="section__desc text--white">
                  Learn more about trends, gold security, safe investments and
                  much more with our curated blogs
                </p>
              </div>
              <div className="col-lg-6">
                <p className="text--white text--semi text--italic blogs__hero-label">
                  <Image
                    style={{ color: undefined }}
                    className="img-fluid"
                    src={BlogHeroIcon}
                    alt="hero icon"
                  />
                  Today&apos;s top read
                </p>
                <div className="blogs__hero-row">
                  <Link
                    href="blogs/instant-gold-loan"
                    className="blogs__card active left mb-0"
                  >
                    <div className="blogs__card-figures">
                      <Image
                        style={{ color: undefined }}
                        className="img-fluid"
                        src={BlogHeaderTile6}
                        alt="Instant gold loan"
                      />
                    </div>
                    <div className="blogs__card-content">
                      <p className="text--black text--bold title">
                        Bullet repayment in Gold Loans
                      </p>
                      <p className="text--gray text--regular desc">
                        The Indian gold loan market is expanding at a CAGR of
                        12.75% and is expected to reach Rs.6275.40 Bn by 2025 .
                        Sometimes,
                      </p>
                    </div>
                  </Link>
                  <Link
                    href="blogs/loan-emi-calculator-complete-guide"
                    className="blogs__card center active  mb-0"
                  >
                    <div className="blogs__card-figures">
                      <Image
                        style={{ color: undefined }}
                        className="img-fluid"
                        src={BlogHeaderTile2}
                        alt="Loan Emi Calculator Completen Guide"
                      />
                    </div>
                    <div className="blogs__card-content">
                      <p className="text--black text--bold title">
                        Top 5 benefits of a Gold Loan
                      </p>
                      <p className="text--gray text--regular desc">
                        Gold has sentimental importance in India as it
                        represents riches and prosperity. In the country, gold
                        decorations and
                      </p>
                    </div>
                  </Link>
                  <Link
                    href="blogs/gold-loan-calculator"
                    className="blogs__card active right mb-0"
                  >
                    <div className="blogs__card-figures">
                      <Image
                        style={{ color: undefined }}
                        className="img-fluid"
                        src={BlogHeaderTile9}
                        alt="Gold loan calculator"
                      />
                    </div>
                    <div className="blogs__card-content">
                      <p className="text--black text--bold title">
                        Who should opt for a Gold Loan?
                      </p>
                      <p className="text--gray text--regular desc">
                        You may face financial emergencies due to unforeseen
                        situations. It could be a
                      </p>
                    </div>
                  </Link>
                </div>
              </div>
            </div>
          </div>
        </section>
        {isSuccess && (
          <section className="bg bg--light">
            <div className="container">
              <h2 className="section__title-small text--black text--bold text-center">
                Increase your financial knowledge
              </h2>
              <div className="row blogs__row">{blogsCards}</div>
              {strapiBlogs.length !== 0 && (
                <p className="text-center">
                  <button
                    className="custom__button custom__button--dark border-btn text--semi text--darkBlue viewMore viewButton"
                    onClick={() => {
                      if (pageNumber === pagination?.pageCount) {
                        setPageNumber(1);
                      } else {
                        setPageNumber(pageNumber + 1);
                      }
                    }}
                  >
                    {pageNumber === pagination?.pageCount
                      ? 'View Less'
                      : 'View More'}
                  </button>
                </p>
              )}
            </div>
          </section>
        )}
      </main>
    </>
  );
}
